import GridView from '@/views/GridView';

const OrderSummaryGridView = GridView.extend({
  className: 'order-summary-grid-view',

  initialize() {}
});

export default OrderSummaryGridView;
